import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSubAgents } from './hooks';
import { getSubAgents } from '../../actions/subAgents';
import { SubAgentListLayout } from '../../components/SubAgentListLayout';
import { useSubAgentsListOpenTracking } from '../../hooks';
import { useObserver } from '../../hooks/useObserver';
import { subAgentsSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';

export const SubAgentsListContainer = () => {
  const { subAgentsList, status, page, search } = useSelector(subAgentsSelector);

  const dispatch = useDispatch();
  const rootElementRef = React.useRef<HTMLDivElement>(null);
  const targetElementRef = React.useRef<HTMLDivElement>(null);

  const isLoading = status === ERequestApiStatus.Pending;

  const handleTracking = useSubAgentsListOpenTracking({ source: 'cross' });

  const handleScroll = React.useCallback(() => {
    if (page.canLoadMore && !isLoading) {
      dispatch(getSubAgents({ offset: subAgentsList.length, search }));
      handleTracking();
    }
  }, [dispatch, handleTracking, isLoading, page.canLoadMore, search, subAgentsList.length]);

  useObserver({
    rootElementRef,
    targetElementRef,
    handler: handleScroll,
  });

  const subAgentsNode = useSubAgents();

  if (!subAgentsNode) {
    return null;
  }

  return (
    <SubAgentListLayout
      rootElementRef={rootElementRef}
      targetElementRef={targetElementRef}
      subAgentsNode={subAgentsNode}
    />
  );
};
